import {Typography} from 'components/Typography';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {FC, useMemo} from 'react';
import style from './style.module.scss';

const MINERALIZATION_CODE = 'mineralization';

export const DetailedCharacteristicsMineralization: FC = () => {
    const productData = useAppSelector(selectProductData);

    const value = useMemo(() => {
        const mineralizationProperty = productData?.properties.find(({code}) => code === MINERALIZATION_CODE);

        if (!mineralizationProperty) {
            return 0;
        }

        return mineralizationProperty.value as number;
    }, [productData]);

    const progressLineStyle = useMemo(() => {
        return {width: `${value / 10}%`};
    }, [value]);

    return (
        <div className={style.main}>
            <div>
                <Typography variant={'title-18-m'}>Минерализация</Typography>
                <Typography className={style.value} variant={'label-16-m'}>
                    {value}
                </Typography>
            </div>
            <div className={style.rangeBlock}>
                <Typography variant={'label-16-m'}>0</Typography>
                <Typography variant={'label-16-m'}>1000</Typography>
            </div>
            <div className={style.progressBlock}>
                <div className={style.progressLine} style={progressLineStyle} />
            </div>
        </div>
    );
};
